import React, { useMemo } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { useAuthState } from 'src/shared/features/auth/api/use-auth-state'

interface AuthGuardProps {
  children: React.ReactNode
  requireAuth?: boolean
  allowUnauthenticatedPaths?: string[]
}

const Guard = ({ children }: AuthGuardProps) => {
  const { isSignedIn } = useAuthState()
  const location = useLocation()

  return useMemo(() => {
    if (
      !isSignedIn &&
      ![paths.auth.login.path, paths.auth.signup.path, paths.auth.confirmAccount.path].includes(
        location.pathname as any,
      )
    ) {
      // Create a full URL that preserves both pathname and search params
      const redirectUrl = location.pathname + (location.search || '')
      return <Navigate to={paths.auth.login.getHref(redirectUrl)} replace />
    }

    return <>{children}</>
  }, [isSignedIn, location.pathname, location.search, children])
}

export const AuthGuard = ({ children }: AuthGuardProps) => {
  return <Guard>{children}</Guard>
}
